var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39775 12.898L15.0953 7.2004C16.4953 5.80045 16.7018 3.49732 15.377 2.02608C15.0451 1.6565 14.6415 1.3584 14.1906 1.14997C13.7398 0.941551 13.2512 0.827174 12.7546 0.813821C12.2581 0.800469 11.7641 0.888422 11.3026 1.07231C10.8412 1.2562 10.4221 1.53218 10.0709 1.8834L9 2.95428L8.0754 2.02968C6.67545 0.629726 4.37232 0.423185 2.90108 1.74801C2.5315 2.07986 2.2334 2.48353 2.02497 2.93439C1.81655 3.38525 1.70217 3.87386 1.68882 4.37038C1.67547 4.86691 1.76342 5.36095 1.94731 5.82236C2.1312 6.28377 2.40718 6.70288 2.7584 7.05411L8.60226 12.898C8.70774 13.0035 8.85082 13.0627 9 13.0627C9.14919 13.0627 9.29226 13.0035 9.39775 12.898V12.898Z",
    stroke: "#123051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.b42e5ee4ffcfe7c18dd699ceb98b4077.svg";
export { ForwardRef as ReactComponent };